import React from 'react';

const HazardIcon = () => {
  return (
    <svg
      width="30"
      height="20"
      viewBox="0 0 39 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_13_608)">
        <path
          d="M2.28564 12C2.28564 5.37258 7.65823 0 14.2856 0H24.2856C30.9131 0 36.2856 5.37258 36.2856 12C36.2856 18.6274 30.9131 24 24.2856 24H14.2856C7.65823 24 2.28564 18.6274 2.28564 12Z"
          fill="#FED1BC"
          shapeRendering="crispEdges"
        />
        <path
          d="M11.0356 18.75H27.5356L19.2856 4.5L11.0356 18.75ZM20.0356 16.5H18.5356V15H20.0356V16.5ZM20.0356 13.5H18.5356V10.5H20.0356V13.5Z"
          fill="black"
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_13_608"
          x="0.285645"
          y="0"
          width="38"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_13_608"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_13_608"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default HazardIcon;
